<!-- <template>
    <div class="footer">
      <div class="footer-bottom">
        <div class="footer-column">
          <h3 class="column-title">{{ $t("generalInformation") }}</h3>
          <div class="column-links">
            <router-link 
              v-for="item in rootFooterMenuItems" 
              :key="item.id"
              :to="{ name: 'menuDetailsNew', params: { id: item.id, slug: item.slug }}"
            >
              {{ item.title }}
            </router-link>
          </div>
        </div>
        
        <div class="footer-column">
          <h3 class="column-title">{{ $t("featured") }}</h3>
          <div class="column-links">
            <router-link 
              v-for="menuItem in rootHeaderMenuItems" 
              :key="menuItem.id"
              :to="{ name: 'menuDetailsNew', params: { id: menuItem.id, slug: menuItem.slug }}"
              class="main-menu-item"
            >
              {{ menuItem.title }}
            </router-link>
          </div>
        </div>
        
        <div class="footer-column" v-if="servicesItems.length">
          <h3 class="column-title">{{ $t("activities") }}</h3>
          <div class="column-links">
            <template v-for="menuItem in servicesItems">
              <a 
                v-if="isExternalLink(menuItem.url)" 
                :href="menuItem.url" 
                class="main-menu-item" 
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ menuItem.title }}
              </a>
              <router-link 
                v-else 
                :to="computeRoute(menuItem)" 
                class="main-menu-item" 
                :key="menuItem.id"
              >
                {{ menuItem.title }}
              </router-link>
            </template>
          </div>
        </div>
        
        <div class="footer-column">
          <h3 class="column-title">{{ $t("Contact") }}</h3>
          <div class="column-links">
            <a href="https://goo.gl/maps/pwWuixvXcYbSgnkv6" target="_blank" class="contact-item">
              <span>Ložionička 3, 71000 Sarajevo</span>
            </a>
            <a href="mailto:info@fia.ba" class="contact-item">
              <span>info@fia.ba</span>
            </a>
            <a class="contact-item">
              <span>+387 33 255 200</span>
            </a>
              <a href="https://ba.linkedin.com/in/finansijsko-informati%C4%8Dka-agencija-fbih-193689171" target="_blank" class="social-logo">
                <i class="fa fa-linkedin" aria-hidden="true"></i>
              </a>
            </div>           
        </div>
      </div>
      
      <div class="copyright">
        <p>@Copyright 2024 - {{ $t("fiaFullName") }}</p>
      </div>
    </div>
  </template>
  
  <script>
  import SubMenuItemFooter from '../menu/SubMenuItemFooter'
  import { mapGetters } from 'vuex'
  
  export default {
    data() {
      return {
        menu: null,
        hierarchyLevel: 0,
        defaultIndent: 10,
        menuHighlightedServices: null
      }
    },
    components: {
      appSubMenuItemFooter: SubMenuItemFooter
    },
    computed: {
      ...mapGetters(["rootFooterMenuItems", "highlightedServicesItems", "rootHeaderMenuItems", "getChildrenByParentId"]),
      servicesItems() {
        let items = [];
        let parent = this.highlightedServicesItems[0];
        if (!parent) return [];
        items = this.getChildrenByParentId(parent.id);
        return items;
      },
    },
    methods: {
      isExternalLink(url) {
        return url != null && (url.startsWith("http") || url.startsWith("https"));
      },
      isInternalLink(url) {
        return url != null && !this.isExternalLink(url);
      },
      computeRoute(menuItem) {
        if (this.isInternalLink(menuItem.url)) {
          return { name: menuItem.url };
        }
        return { name: 'menuDetailsNew', params: { id: menuItem.id, slug: menuItem.slug } };
      }
    }
  }
  </script>
  
  <style scoped>
  .footer {
    background-color: var(--main-color);
    /* padding: 30px 5% 10px; */
    /* padding: 10px 7% 10px 7%; */
    padding: 20px 0%;
  }
  
  /* Bottom row with columns */
  .footer-bottom {
    display: flex;
    justify-content: space-between;
    /* gap: auto; */
    width: 55%;
    margin-left: auto;
    margin-right: auto;
  }
  
  .footer-column {
    /* flex: 1; */
    
  }
  
  .column-title {
    color: var(--light-color);
    font-size: 1.25rem;
    line-height: 1.5;
    /* font-weight: 600; */
    /* margin: 0 0 15px 0; */
    margin: 0 0 4px 0;
    padding: 0;
    text-transform: uppercase;
    font-weight: 600;
    /* letter-spacing: -1px; */
  }

  .column-title a{
    color: var(--light-color);
    text-decoration: none;
  }
  .column-links {
    display: flex;
    flex-direction: column;
    /* gap: 8px; */
  }
  
  .column-links a {
    color: var(--light-color);
    text-decoration: none;
    font-size: 1.15rem;
    line-height: 1.5;
    transition: opacity 0.2s;
    display: block;
    /* padding: 2px 0; */
  }
  
  .column-links a:hover {
    opacity: 0.8;
  }
  
  .contact-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .contact-item i {
    width: 16px;
    text-align: center;
  }
  
  
  .social-icons a {
    font-size: 1.3rem;
    margin-right: 10px;
  }
  
  .copyright {
    text-align: center;
    margin-top: 15px;
    padding-top: 5px;
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.8);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .copyright p {
    margin: 0;
  }

  .social-logo i{
    font-size: 25px;
  }
  
  @media only screen and (max-width: 992px) {
    .footer {
    padding: 10px 7%;
  }

    .footer-bottom {
      /* flex-direction: column; */
      display: flex;
      width: 100%;
      margin: 0;
      gap: 15px;
    }
    
    .footer-column {
      width: 100%;
    }
    
    .column-links {
      gap: 2px;
    }
  }

  @media only screen and (max-width: 480px) {
  .footer-bottom {
      flex-direction: column;  
    }

  }
  </style> -->

<template>
  <div class="footer">
    <div class="footer-content">
      <div class="footer-bottom">
        <div class="footer-column">
          <h3 class="column-title">{{ $t("generalInformation") }}</h3>
          <div class="column-links">
            <router-link v-for="item in rootFooterMenuItems" :key="item.id"
              :to="{ name: 'menuDetailsNew', params: { id: item.id, slug: item.slug } }">
              {{ item.title }}
            </router-link>
          </div>
        </div>

        <div class="footer-column">
          <h3 class="column-title">{{ $t("featured") }}</h3>
          <div class="column-links">
            <router-link v-for="menuItem in rootHeaderMenuItems" :key="menuItem.id"
              :to="{ name: 'menuDetailsNew', params: { id: menuItem.id, slug: menuItem.slug } }" class="main-menu-item">
              {{ menuItem.title }}
            </router-link>
          </div>
        </div>

        <div class="footer-column" v-if="servicesItems.length">
          <h3 class="column-title">{{ $t("activities") }}</h3>
          <div class="column-links">
            <template v-for="menuItem in servicesItems">
              <a v-if="isExternalLink(menuItem.url)" :href="menuItem.url" class="main-menu-item" target="_blank"
                rel="noopener noreferrer">
                {{ menuItem.title }}
              </a>
              <router-link v-else :to="computeRoute(menuItem)" class="main-menu-item" :key="menuItem.id">
                {{ menuItem.title }}
              </router-link>
            </template>
          </div>
        </div>

        <div class="footer-column">
          <h3 class="column-title">{{ $t("Contact") }}</h3>
          <div class="column-links">
            <a href="https://goo.gl/maps/pwWuixvXcYbSgnkv6" target="_blank" rel="noopener noreferrer"
              class="contact-item">
              <i class="fa fa-map-marker" aria-hidden="true"></i>
              <span>Ložionička 3, 71000 Sarajevo</span>
            </a>
            <a href="mailto:info@fia.ba" class="contact-item">
              <i class="fa fa-envelope" aria-hidden="true"></i>
              <span>info@fia.ba</span>
            </a>
            <a class="contact-item">
              <i class="fa fa-phone" aria-hidden="true"></i>
              <span>+387 33 255 200</span>
            </a>
            <div class="social-links">
              <a href="https://ba.linkedin.com/in/finansijsko-informati%C4%8Dka-agencija-fbih-193689171" target="_blank"
                rel="noopener noreferrer" class="social-logo" aria-label="LinkedIn">
                <i class="fa fa-linkedin" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="copyright">
        <p>@Copyright 2024 - {{ $t("fiaFullName") }}</p>
        <p class="cookie-links">
          <router-link :to="cookiePolicyRoute">{{ $t("cookiePolicyTitle") }}</router-link>
          <span aria-hidden="true">|</span>
          <a href="#" @click.prevent="openCookieSettings">{{ $t("cookieSettings") }}</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import SubMenuItemFooter from '../menu/SubMenuItemFooter'
import { mapGetters } from 'vuex'
import { openCookieSettings } from '../../cookieConsent.js'

export default {
  data() {
    return {
      menu: null,
      hierarchyLevel: 0,
      defaultIndent: 10,
      menuHighlightedServices: null
    }
  },
  components: {
    appSubMenuItemFooter: SubMenuItemFooter
  },
  computed: {
    ...mapGetters(["rootFooterMenuItems", "highlightedServicesItems", "rootHeaderMenuItems", "getChildrenByParentId"]),
    servicesItems() {
      let items = [];
      let parent = this.highlightedServicesItems[0];
      if (!parent) return [];
      items = this.getChildrenByParentId(parent.id);
      return items;
    },
    cookiePolicyRoute() {
      const lang = this.$route.params.lang || this.$i18n.locale;
      return { name: lang === 'en' ? 'cookie-policy' : 'politika-kolacica', params: { lang: lang } };
    },
  },
  methods: {
    openCookieSettings() {
      openCookieSettings();
    },
    isExternalLink(url) {
      return url != null && (url.startsWith("http") || url.startsWith("https"));
    },
    isInternalLink(url) {
      return url != null && !this.isExternalLink(url);
    },
    computeRoute(menuItem) {
      if (this.isInternalLink(menuItem.url)) {
        return { name: menuItem.url };
      }
      return { name: 'menuDetailsNew', params: { id: menuItem.id, slug: menuItem.slug } };
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: var(--main-color);
  /* padding: 30px 5% 10px; */
  /* padding: 10px 7% 10px 7%; */
  padding: 40px 0 0;
  position: relative;
}

.footer-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 7%;
}

.footer-bottom {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 50px;
  margin-bottom: 40px;
}

.column-title {
  color: var(--light-color);
  font-size: 1rem;
  margin: 0 0 12px 0;
  padding: 0 0 12px 0;
  text-transform: uppercase;
  letter-spacing: .5px;
  position: relative;
}

.column-title a {
  color: var(--light-color);
  text-decoration: none;
}

.column-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.column-links a {
  color: var(--light-color);
  text-decoration: none;
  font-size: 1rem;
  line-height: 1.1;
  transition: all 0.3s ease;
  display: inline-block;
  position: relative;
  padding-left: 0;
}

.column-links a::before {
  content: '';
  position: absolute;
  left: -15px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 2px;
  background: var(--light-color);
  transition: width 0.3s ease;
}

.column-links a:hover {
  color: var(--light-color);
  padding-left: 15px;
  transform: translateX(2px);
}

.column-links a:hover::before {
  width: 8px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.contact-item i {
  width: 20px;
  text-align: center;
  color: var(--light-color);
  transition: transform 0.3s ease;
  margin-right: 5px;
}

.contact-item:hover i {
  transform: scale(1.2);
}

.social-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.social-logo i {
  font-size: 1.5rem;
  color: var(--light-color);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-logo:hover i {
  color: rgba(255, 255, 255, 0.7);
  transform: scale(1.15);
}

.copyright {
  text-align: center;
  /* margin-top: 15px; */
  padding: 5px;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.8);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.copyright p {
  margin: 0;
}

.cookie-links {
  margin-top: 4px !important;
}

.cookie-links a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: underline;
}

.cookie-links a:hover {
  color: var(--light-color);
}

.cookie-links span {
  margin: 0 8px;
}

@media only screen and (max-width: 1200px) {
  .footer-bottom {
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
  }
}

@media only screen and (max-width: 992px) {
  .footer {
    padding: 40px 0 0;
  }

  .footer-content {
    padding: 0 7%;
  }

  .footer-bottom {
    grid-template-columns: 1fr;
    gap: 35px;
    margin-bottom: 35px;
  }

  .column-title {
    font-size: 1rem;
    margin-bottom: 15px;
    padding-bottom: 10px;
  }

  .column-links {
    gap: 10px;
  }

  .column-links a {
    font-size: 0.95rem;
  }

  .copyright {
    font-size: 0.85rem;
    padding: 20px 0;
  }
}

@media only screen and (max-width: 480px) {
  .footer {
    padding: 30px 0 0;
  }

  .footer-bottom {
    gap: 30px;
  }

  .column-title {
    font-size: 0.95rem;
  }

  .column-links a {
    font-size: 0.9rem;
  }

  .social-logo {
    width: 36px;
    height: 36px;
  }

  .social-logo i {
    font-size: 1.1rem;
  }

}
</style>